<template>
    <v-dialog v-model="modalProp" width="500">
        <v-card>
            <v-card-title class="headline grey lighten-2">
                Change Email address
                <v-spacer />
                <v-btn
                    icon
                    @click="modalProp = false"
                >
                    <v-icon>{{ mdiClose }}</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="mt-6">
                <!-- Current Email address -->
                <v-text-field
                    label="Current email address"
                    :value="userEmailAdd"
                    color="green accent-4"
                    autocomplete="nope"
                    readonly
                />

                <!-- New Emaill Address -->
                <v-text-field
                    v-model="newMail"
                    label="Enter new email address"
                    :rules="rules.emailRules"
                    color="green accent-4"
                    autocomplete="nope"
                    @keypress.enter="updateEmail()"
                />
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn color="green" text @click="updateEmail()">
                    Update
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import { mapActions } from 'vuex'
export default {
    props: ['editEmail', 'userEmailAdd'],
    data: () => ({
        mdiClose,
        newMail: '',
        rules: {
            emailRules: [
                v => !!v || 'Email is required',
                v => /^[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/.test(v) || 'E-mail must be valid'
            ]
        }
    }),
    computed: {
        modalProp: {
            get() {
                return this.editEmail
            },
            set(val) {
                this.$emit('showDlgEditEmail', val)
            }
        }
    },

    methods: {
        ...mapActions(['manageAccountEmail']),

        updateEmail() {
            if(this.newMail != ''  && /.+@.+/.test(this.newMail)){
                this.manageAccountEmail({
                    MEMBN: this.$cookies.get('usermembn'),
                    NEW_EMAIL: this.newMail
                }).then(() => {
                    this.modalProp = false
                }).then(() => {
                    window.location.reload()
                })
            }
        }
    }
}
</script>

<style></style>
